module.exports = __webpack_public_path__ + "img/img_cs_phone_img3.62d23090.png";